export const adaptValidarInsumos = (insumo) => {
    return {
        idInsumoN: insumo?.idInsumoN,
        idInsumo: insumo?.idInsumo,
        descripcion: insumo?.descripcion,
        descripcionGenerica: insumo?.descripcionGenerica,
        activo: insumo?.activo,
        validado: insumo?.validado
    }
}

export const adaptValidarInsumoArray = (
    insumos
) => {
    return structuredClone(insumos?.allValidarInsumo?.items)
        ?.map(insumo => adaptValidarInsumos(insumo));
}

export const adaptValidarInsumoExportArray = (
    allValidarInsumoForExport
) => {
    return structuredClone(allValidarInsumoForExport)
        ?.map(insumo => adaptValidarInsumos(insumo));
}